import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import DuplicateBtn from './DuplicateBtn'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

const TaxeVentilationArticleSelect = (props) => {
    const t = useTranslate();

    const handleChange = (e,correspondance,ventilationField) => {
        props.setVentialtionArticleTaxeValue(prevState => {
            return {
                ...prevState,
                [props.taux]: prevState[props.taux].map(field => 
                    field.fieldName === ventilationField ? { ...field, [correspondance]: e.target.value } : field
                )
            };
        });
    };

    const handleRemoveLine = (fieldName) => {
        let newData = {}

        Object.entries(props.ventialtionArticleTaxeValue).map(([keyIndex,datas])=>{
            let filteredNexData = datas.filter(item => item.fieldName!=fieldName)
            newData[keyIndex] = filteredNexData
        })

        props.setVentialtionArticleTaxeValue(newData)
    };

    return(<span className='pb-3'>
        <label className='d-flex justify-content-center mb-1 fw-bold position-relative'>
            {t('ventilationItem')}
            <div style={{position:'absolute', right:'0.6%'}}>
                {(props.authParam.company.advanceparams.taux_tgc.length > 1) && 
                    <DuplicateBtn 
                        authParam={props.authParam} 
                        colTaux={props.taux}
                        ventialtionArticleTaxeValue={props.ventialtionArticleTaxeValue} 
                        setVentialtionArticleTaxeValue={props.setVentialtionArticleTaxeValue} 
                    />
                }
            </div>
        </label>
        {props.ventialtionArticleTaxeValue[props.taux].map((value, index)=>{
            return(
                <div key={index} className="row">
                    {index==0 &&
                        <>
                            <span className="col-6 form-group" style={{marginBottom:'0'}}>
                                <label>Code</label>
                            </span>
                            <span className="col-6 form-group" style={{marginBottom:'0'}}>
                                <label>{t('wording')}</label>
                            </span>
                        </>
                    }
                    <div className="col-12 fw-bold text-primary d-flex justify-content-between">
                        {
                            value.fieldName=='default' ? t('defaultValue') 
                            : value.fieldName=='giftcard' ? t('giftcard')
                            : value.fieldName
                        }
                        {value.fieldName!='default' && value.fieldName!='giftcard' && <FontAwesomeIcon icon={faTrash} className='text-danger pointer' onClick={()=>handleRemoveLine(value.fieldName)}/> }
                    </div>
                    <div className="col-6 form-group">
                        <input
                            disabled={props.validButton} 
                            value={value.code} 
                            type="text" 
                            className='form-control' 
                            onChange={(e)=>handleChange(e, 'code', value.fieldName)} 
                        />
                    </div>
                    <div className="col-6 form-group">
                        <input
                            disabled={props.validButton} 
                            value={value.libelle} 
                            type="text" 
                            className='form-control' 
                            onChange={(e)=>handleChange(e, 'libelle', value.fieldName)} 
                        />
                    </div>
                </div>
            )
        })}
    </span>
    )
}

export default TaxeVentilationArticleSelect;





